module.exports = __webpack_public_path__ + "static/media/timeline-copy-2.739615a7.png";